import { render } from "./paythanks.vue?vue&type=template&id=10a4de31"
import script from "./paythanks.vue?vue&type=script&lang=js"
export * from "./paythanks.vue?vue&type=script&lang=js"

import "./paythanks.vue?vue&type=style&index=0&id=10a4de31&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__